function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Dropdown, DropdownList, DropdownListContainer, KEYBOARD_KEYS, Loader } from '@keen.io/ui-core';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';
import { LoaderWrapper, SuggestionsWrapper, LabelWrapper } from './FilterSuggestions.styles';
import { useTranslation } from 'react-i18next';

var FilterSuggestions = function FilterSuggestions(_ref) {
  var suggestionsLoading = _ref.suggestionsLoading,
      suggestions = _ref.suggestions,
      filterValue = _ref.filterValue,
      onSelect = _ref.onSelect,
      suggestionsVisible = _ref.suggestionsVisible;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var filteredSuggestions = suggestions ? suggestions.filter(function (suggestion) {
    return suggestion && suggestion.startsWith(filterValue);
  }) : [];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectionIndex = _useState2[0],
      setIndex = _useState2[1];

  var selectionIndexRef = useRef(selectionIndex);
  var suggestionsListRef = useRef(filteredSuggestions);
  selectionIndexRef.current = selectionIndex;
  suggestionsListRef.current = filteredSuggestions;
  var dropdownIsOpen = suggestionsVisible && filterValue && (suggestionsLoading || filteredSuggestions.length > 0);
  var keyboardHandler = useCallback(function (e) {
    var suggestions = suggestionsListRef.current;

    switch (e.keyCode) {
      case KEYBOARD_KEYS.ENTER:
        if (suggestions && suggestions.length) {
          var value = suggestions[selectionIndexRef.current];
          onSelect(value);
        }

        break;

      case KEYBOARD_KEYS.UP:
        e.preventDefault();

        if (selectionIndexRef.current === null) {
          setIndex(0);
        } else if (selectionIndexRef.current > 0) {
          setIndex(selectionIndexRef.current - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        e.preventDefault();

        if (selectionIndexRef.current === null) {
          setIndex(0);
        } else if (selectionIndexRef.current < suggestions.length - 1) {
          setIndex(selectionIndexRef.current + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        onSelect(null);
        break;
    }
  }, [filteredSuggestions]);
  useEffect(function () {
    document.addEventListener('keydown', keyboardHandler);
    return function () {
      document.removeEventListener('keydown', keyboardHandler);
    };
  }, [dropdownIsOpen]);
  useEffect(function () {
    setIndex(filteredSuggestions.findIndex(function (suggestion) {
      return suggestion === filterValue;
    }));
  }, [filterValue]);
  return React.createElement(Dropdown, {
    isOpen: dropdownIsOpen,
    fullWidth: true
  }, React.createElement(SuggestionsWrapper, null, React.createElement(LabelWrapper, null, React.createElement(BodyText, {
    variant: "body2",
    color: colors.gray[500]
  }, t('query_creator_filters.matching_values'))), suggestionsLoading && React.createElement(LoaderWrapper, {
    "data-testid": "suggestions-loader"
  }, React.createElement(Loader, {
    fill: colors.blue['500'],
    width: 50,
    height: 50
  })), !suggestionsLoading && filteredSuggestions.length > 0 && React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 140,
    scrollShadow: true
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      padding: "0 0 10px 0",
      ref: activeItemRef,
      items: filteredSuggestions.map(function (value) {
        return {
          label: value,
          value: value
        };
      }),
      setActiveItem: function setActiveItem(_item, idx) {
        return selectionIndexRef.current === idx;
      },
      onClick: function onClick(_e, _ref2) {
        var value = _ref2.value;
        onSelect(value);
      }
    });
  })));
};

export default FilterSuggestions;